/* eslint-disable react/prop-types */
import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { Row } from 'hedron';
import CalculatorDetailsItem from 'kentico-blocks/Calculator/CalculatorDetailsItem';
import {
  PaddedBottomRow,
  PaddedTopRow,
} from 'kentico-blocks/Calculator/styled';
import FullWidthCalculatorDetailsItem
  from 'kentico-blocks/Calculator/FullWidthCalculatorDetailsItem';

@inject('calculatorStore', 'windowStore')
@observer
class TotalOptimisationGrid extends Component {
  render() {
    const {
      windowStore,
      calculatorStore,
      data: {
        currency,

        conferenceRoomsDetailsViewIcon,
        employeesDetailsViewIcon,
        desksMainDetailsIcon,
        parkingSpotsDetailsViewIcon,

        averageSizeOfConferenceRoom,
        averageWorkingHoursPerMonth,
        estimatedAreaOfOneDesk,

        numberOfConferenceRoomsLabel,
        monthlyM2RentPriceLabel,
        numberOfEmployeesLabel,
        averageEmployeeSalaryPerHourLabel,
        totalOptimisationPerMonthLabel,
        numberOfDesksLabel,
        numberOfParkingSpotsLabel,
        pricePerParkingSpotLabel,
        optimisationRatesHeading,

        roomsOptimisationLabel,
        workOptimisationLabel,
        desksOptimisationLabel,
        parkingOptimisationLabel,
      },
    } = this.props;

    return (
      <React.Fragment>
        <PaddedTopRow>
          {/* FIRST ROW */}
          <CalculatorDetailsItem
            icon={conferenceRoomsDetailsViewIcon}
            calculatorValue={averageSizeOfConferenceRoom}
            sign="x"
          />
          <CalculatorDetailsItem
            label={numberOfConferenceRoomsLabel}
            value={calculatorStore.numberOfConferenceRooms.get()}
            sign="x"
          />
          <CalculatorDetailsItem
            label={monthlyM2RentPriceLabel}
            value={calculatorStore.monthlyM2RentPrice.get()}
            unit={currency}
            sign="x"
          />
          <CalculatorDetailsItem
            label={optimisationRatesHeading}
            value={calculatorStore.conferenceRoomOptimisationRate * 100}
            unit="%"
            sign={windowStore.isOnDesktop ? '=' : ''}
            white={windowStore.isOnDesktop}
            center
            labelBold
            smallPadding
          />
          {windowStore.isOnDesktop
            ? (
              <CalculatorDetailsItem
                value={calculatorStore.roomOptimisation}
                unit={currency}
                sign="+"
                signBottom
                valueBold
              />
            )
            : (
              <FullWidthCalculatorDetailsItem
                value={calculatorStore.roomOptimisation}
                unit={currency}
                label={roomsOptimisationLabel}
                valueBold
                sign="="
              />
            )
          }
        </PaddedTopRow>
        <Row>
          {/* SECOND ROW */}
          <CalculatorDetailsItem
            icon={employeesDetailsViewIcon}
            calculatorValue={averageWorkingHoursPerMonth}
            sign="x"
          />
          <CalculatorDetailsItem
            label={numberOfEmployeesLabel}
            value={calculatorStore.numberOfEmployees.get()}
            sign="x"
          />
          <CalculatorDetailsItem
            label={averageEmployeeSalaryPerHourLabel}
            value={calculatorStore.averageEmployeeSalaryPerH.get()}
            unit={currency}
            sign="x"
          />
          <CalculatorDetailsItem
            value={calculatorStore.workingHoursOptimisationRate * 100}
            unit="%"
            sign={windowStore.isOnDesktop ? '=' : ''}
            white={windowStore.isOnDesktop}
            center
          />
          {windowStore.isOnDesktop
            ? (
              <CalculatorDetailsItem
                value={calculatorStore.employeeOptimisation}
                unit={currency}
                sign="+"
                signBottom
                valueBold
              />
            ) : (
              <FullWidthCalculatorDetailsItem
                value={calculatorStore.employeeOptimisation}
                unit={currency}
                label={workOptimisationLabel}
                valueBold
                sign="="
              />
            )}
        </Row>
        <Row>
          {/* THIRD ROW */}
          <CalculatorDetailsItem
            icon={desksMainDetailsIcon}
            calculatorValue={estimatedAreaOfOneDesk}
            sign="x"
          />
          <CalculatorDetailsItem
            label={numberOfDesksLabel}
            value={calculatorStore.numberOfDesks.get()}
            sign="x"
          />
          <CalculatorDetailsItem
            label={monthlyM2RentPriceLabel}
            value={calculatorStore.monthlyM2RentPrice.get()}
            unit={currency}
            sign="x"
          />
          <CalculatorDetailsItem
            value={calculatorStore.desksOptimisationRate * 100}
            unit="%"
            sign={windowStore.isOnDesktop ? '=' : ''}
            white={windowStore.isOnDesktop}
            center
          />
          {windowStore.isOnDesktop ? (
            <React.Fragment>
              <CalculatorDetailsItem
                value={calculatorStore.desksOptimisation}
                unit={currency}
                sign="+"
                signBottom
                valueBold
              />
              <CalculatorDetailsItem
                label={totalOptimisationPerMonthLabel}
                labelBold
                labelWide
                value={calculatorStore.totalOptimisationPerMonth}
                unit={currency}
                sign="="
                signLeft
                bigUnit
                valueBold
                alignRight
              />
            </React.Fragment>
          ) : (
            <FullWidthCalculatorDetailsItem
              value={calculatorStore.desksOptimisation}
              unit={currency}
              label={desksOptimisationLabel}
              valueBold
              sign="="
            />
          )}
        </Row>
        <PaddedBottomRow>
          {/* FOURTH ROW */}
          {windowStore.isOnDesktop && (
            <CalculatorDetailsItem
              icon={parkingSpotsDetailsViewIcon}
            />
          )}
          <CalculatorDetailsItem
            label={numberOfParkingSpotsLabel}
            value={calculatorStore.numberOfParkingSpots.get()}
            sign="x"
          />
          <CalculatorDetailsItem
            label={pricePerParkingSpotLabel}
            value={calculatorStore.pricePerParkingSpot.get()}
            unit={currency}
            sign="x"
            mobileWidth2x
          />
          <CalculatorDetailsItem
            value={calculatorStore.parkingOptimisationRate * 100}
            unit="%"
            sign={windowStore.isOnDesktop ? '=' : ''}
            white={windowStore.isOnDesktop}
            center
          />
          {windowStore.isOnDesktop ? (
            <CalculatorDetailsItem
              value={calculatorStore.parkingOptimisation}
              unit={currency}
              valueBold
            />
          ) : (
            <FullWidthCalculatorDetailsItem
              value={calculatorStore.parkingOptimisation}
              unit={currency}
              label={parkingOptimisationLabel}
              valueBold
              sign="="
            />
          )}
        </PaddedBottomRow>
        {!windowStore.isOnDesktop && (
          <PaddedBottomRow>
            <FullWidthCalculatorDetailsItem
              value={calculatorStore.totalOptimisationPerMonth}
              valueBold
              unit={currency}
              bigUnit
              label={totalOptimisationPerMonthLabel}
              labelBold
              center
            />
          </PaddedBottomRow>
        )}
      </React.Fragment>
    );
  }
}

export default TotalOptimisationGrid;



// WEBPACK FOOTER //
// ./src/kentico-blocks/Calculator/CalculatorDetailsView/TotalOptimisationGrid/index.jsx